<script>
import MultipleRadios from '@wielink-application/shared/vue/components/form/horizontal/multiple-radios.vue'

export default MultipleRadios;
</script>